import { Button, TextField, InputAdornment } from "@mui/material";
import { Search, FilterList } from "@mui/icons-material";
import React from "react";

export default function SearchFilterComponent({
	tagType,
	options,
	onChangeText,
	onFilterKeyPress,
	handleFilterClick,
	buttonRef,
}: any) {

	const tagMappings: any = {
		Municipality: { placeholder: "Search by city", key: "city" },
		Hoa: { placeholder: "Search by HOA name", key: "name" },
		Properties: { placeholder: "Search by external Id", key: "externalId" },
		Document: { placeholder: "Search by Name/External ID/Vendor ID", key: "searchKeyword" },
		Mail: { placeholder: "Search by Sent To/Sent From", key: "mailSearchKeyword" },
		Email: { placeholder: "Search by Subject/Sent From", key: "emailSearchKeyword" },
		PropertyTask: { placeholder: "Search by Operator Name", key: "operatorName" },
		default: { placeholder: "Search by street", key: "street" },
	};

	const { placeholder, key } = tagMappings[tagType] || tagMappings.default;

	return (
		<div style={{ marginRight: "16px" }}>
			<TextField
				variant="outlined"
				placeholder={placeholder}
				name={key}
				value={options[key] || ""}
				onChange={onChangeText}
				onKeyDown={onFilterKeyPress}
				style={{ boxSizing: "border-box" }}
				sx={{
					"&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
						borderColor: "#E8E8E8",
					},
					"& .MuiInputBase-root.Mui-focused fieldset": { borderColor: "#E8E8E8" },
					"& .MuiOutlinedInput-adornedEnd": { paddingRight: "0px" },
				}}
				InputProps={{
					margin: "none",
					className: "searchInputClass",
					startAdornment: (
						<InputAdornment position="start">
							<Search style={{ color: "#9F9F9F" }} />
						</InputAdornment>
					),
					endAdornment: (
						<Button
							id="end-filtering-icon-title"
							ref={buttonRef}
							onClick={handleFilterClick}
							style={{
								minWidth: "98px",
								height: "100%",
								padding: "0px",
								textTransform: "capitalize",
							}}
							startIcon={<FilterList style={{ color: "#9F9F9F" }} />}
						>
							Filter
						</Button>
					),
				}}
				type="search"
			/>
		</div>
	);
}
